import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

function Home2() {
  const { t } = useLanguage();

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row className="align-items-center">
          <Col lg={7} className="home-about-description">
            <p className="section-label">{t("home.aboutLabel")}</p>
            <h2>
              {t("home.aboutTitle")}{" "}
              <span className="purple">{t("home.aboutEmphasis")}</span>
            </h2>
            <p className="home-about-body">{t("home.aboutBody")}</p>
            <Link to="/about" className="text-link">{t("home.aboutLink")}</Link>
          </Col>
          <Col lg={5} className="myAvtar">
            <div className="avatar-frame">
              <img src={myImg} className="img-fluid" alt="avatar" />
              <span>{t("home.location")}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <p className="section-label">{t("home.socialLabel")}</p>
            <h2>{t("home.socialTitle")}</h2>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/zainalsalamun"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/zainalsalamun"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/zainal-salamun-660a9598/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/zainalsalamun"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
